import styled from 'styled-components';
const IndexStyled = styled.div`
  height: 100%;
  > form {
    /* height: calc(100vh - 151px); */
    /* border: 1px solid red; */
    min-height: 750px;
    height: 100%;
    overflow-y: hidden;
  }
  .form {
    /* border: 1px solid red; */
    overflow-y: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .diff-content {
    flex: 1;
    border-radius: 14px;
    background-color: #fff;
    /* overflow-y: hidden; */
  }
  .MuiIconButton-root {
    width: 16px;
    height: 16px;
  }
  .MuiSvgIcon-root {
    width: 16px;
    height: 16px;
  }
  .red {
    color: #ff0000;
  }
`;
export default IndexStyled;
